import template from './template.html';
import './styles.css';

controller.$inject = ['StoresService', 'UserService', '$stateParams', '$state', 'Alerts'];

export function controller(StoresService, UserService, $stateParams, $state, Alerts) {
    const vm = this;

    let originalStoreData = {};
    let validationErrors = [];
    vm.saveStore = saveStore;
    vm.deleteStore = deleteStore;
    vm.back = back;
    vm.loading = false;

    //permissions based control
    vm.userCanAdd = false;
    vm.userCanEdit = false;
    vm.formEnabled = () => ((vm.mode == 'Add' && vm.userCanAdd) || (vm.mode == 'Edit' && vm.userCanEdit));
    vm.deleteEnabled = () => (vm.mode == 'Edit' && vm.userCanEdit);

    init();

    function init() {
        getStore();
        getRoles();
    }

    function back() {
        $state.go('stores', {}, {
            reload: true
        });
    }

    function getStore() {
        const storeId = $stateParams.id;

        if (storeId) {
            vm.loading = true;
            StoresService.getStore(storeId).then(data => {
                vm.store = data;
                vm.mode = 'Edit';
                originalStoreData = angular.copy(data);
                vm.loading = false;
            });
        } else {
            vm.store = {
                id: 0,
                storeId: '',
                storeName: ''
            };
            vm.mode = 'Add';
        }
    }

    function getRoles() {
        UserService.isInRole('EditStore').then(result => vm.userCanEdit = result);
        UserService.isInRole('AddStore').then(result => vm.userCanAdd = result);
    }

    function saveStore() {

        preSaveFormatting();
        validate();

        if (validationErrors.length > 0) {
            Alerts.show('Invalid Store', validationErrors[0], 'error');
            return;
        }

        StoresService.checkStoreIdTaken(vm.store).then(result => {

            if (result === true) {
                Alerts.show('Failed!', 'Store Number already taken.', 'error');
                return;
            }

            let proceed = false;

            if (storeIdModified() && hasAssociatedData()) {
                Alerts.show({
                    title: 'Are you sure?',
                    text: 'Changing the store number will update\nall related drivers and shifts to match.',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, change it!',
                    closeOnConfirm: false
                }, function () {
                    proceed = true;
                });
            } else {
                proceed = true;
            }

            if (proceed) {
                StoresService.saveStore(vm.store).then(() => {
                    Alerts.show({ title: 'Success!', text: 'Store Saved!', type: 'success' }, () => {
                        $state.go('stores', {}, {
                            reload: true
                        });
                    });
                });
            }
        });
    }

    function preSaveFormatting() {
        vm.store.postCode = vm.store.postCode.toUpperCase();
        vm.store.region = vm.store.region.toUpperCase();
    }

    function validate() {
        validationErrors.length = 0;
        if (vm.store.region.substring(0, 1) != vm.store.zone) {
            validationErrors.push('First letter of region must match zone.');
        }
    }

    function storeIdModified() {
        if (vm.mode == 'Edit' && vm.store.storeId != originalStoreData.storeId) {
            return true;
        }
        return false;
    }

    function deleteStore() {
        if (hasAssociatedData()) {
            Alerts.show('Failed!', 'This store has data associated\nwith it and cannot be deleted.', 'error');
        } else {
            Alerts.show({
                title: 'Are you sure?',
                text: 'Store deletions cannot be undone',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                closeOnConfirm: false
            }, function () {
                StoresService.deleteStore(vm.store.storeId).then(() => {
                    Alerts.show({ title: 'Success!', text: 'Store Deleted!', type: 'success' }, () => {
                        $state.go('stores', {}, {
                            reload: true
                        });
                    });
                });
            });
        }
    }

    function hasAssociatedData() {
        return vm.store.hasDrivers || vm.store.hasShifts;
    }

}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('stores.edit', {
        url: '^/stores/:id',
        controller: controller,
        controllerAs: 'vm',
        template: template,
        params: {
            id: {
                squash: 'new',
                value: null
            }
        },
        parent: 'authorised'
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/authorised/storeedit/index.js